import {token} from 'brandi';

import {ProjectUserAuth} from '@specials/project-user';

import {ProjectApiHeaders} from '@/services/ProjectAuthApi/ProjectApiHeaders';
import {ProjectAuthApi} from '@/services/ProjectAuthApi/ProjectAuthApi';
import {ProjectUserInfoData, ProjectUserLoginData} from '@/services/ProjectAuthApi/types';

export const AUTH_TOKENS = {
  projectAuthApi: token<ProjectAuthApi>('projectAuthApi'),
  projectUserAuth: token<ProjectUserAuth<ProjectUserInfoData, ProjectUserLoginData>>('projectUserAuth'),
  projectApiHeaders: token<ProjectApiHeaders>('projectApiHeaders'),
};
